import AreaList from "./AreaList";
import CompanyUsersList from "./CompanyUsersList";

export default {
    AreaList,
    CompanyUsersList
}